export default {
  BLOG_POST: 'blog-post',
  BLOG_LIST: 'blog-list'
};
